export default {
    home: {
        en: {
            title: 'Mobile Hotspot for Travel, Unlimited Data in 100+ Countries | Skygo WiFi',
            description: 'Skygo WiFi offers global pocket WiFi rental with airport pickup at LAX, SFO, and SEA. Enjoy fast, secure internet in over 100 countries — no SIM card or shipping required.',
            keywords: 'pocket WiFi rental, global WiFi, travel WiFi, international WiFi rental, airport WiFi pickup, portable WiFi for travel, global internet access, USA airport WiFi rental, Portable WiFi hotspot, Fast WiFi, Secure internet, 24/7 WiFi, International WiFi rental, Pocket WiFi for travel, Multi-device WiFi, Same-day WiFi pickup, On-demand WiFi rental'
        },
        jp: {
            title: 'ホーム — SkyGo',
            description: 'Skygo WiFiは、海外旅行や出張に最適なレンタルポケットWiFi。 LAXやSFO空港で受け取り、世界100か国以上で高速インターネット接続が可能です。',
            keywords: 'レンタルWiFi, ポケットWiFiレンタル, 海外WiFiレンタル, 海外用WiFi, 海外旅行 WiFi, 空港受け取り WiFi, グローバルWiFi, 海外インターネット接続, 高速WiFi, 安全なインターネット, 24時間WiFi, 海外旅行WiFi, 国内WiFiレンタル, WiFiレンタルサービス, ポータブルWiFi, 複数デバイス接続WiFi, 即日受取WiFi'
        }
    },
}
